import { render, staticRenderFns } from "./createAskFrom.vue?vue&type=template&id=58f4723f&scoped=true&"
import script from "./createAskFrom.vue?vue&type=script&lang=js&"
export * from "./createAskFrom.vue?vue&type=script&lang=js&"
import style0 from "./createAskFrom.vue?vue&type=style&index=0&id=58f4723f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4723f",
  null
  
)

component.options.__file = "createAskFrom.vue"
export default component.exports